import { Outlet, createFileRoute } from '@tanstack/react-router'

import { NodeDetailsPanel } from '@/licenses-tree/components/NodeDetailsPanel'

export const Route = createFileRoute(
  '/company/_management/licenses-structure/$nodeId/_panel',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <NodeDetailsPanel>
      <Outlet />
    </NodeDetailsPanel>
  )
}
